import { useEffect } from 'react';

// 苹果风滚动渐显：为所有 .s-reveal 元素在进入视口时添加 is-visible。
export function useScrollReveal() {
  useEffect(() => {
    const nodes = Array.from(document.querySelectorAll('.s-reveal'));
    if (nodes.length === 0) return undefined;

    if (typeof IntersectionObserver === 'undefined') {
      nodes.forEach((node) => node.classList.add('is-visible'));
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' },
    );

    nodes.forEach((node) => observer.observe(node));
    return () => observer.disconnect();
  }, []);
}
